import { api_GET, api_POST, api_PUT, api_DELETE } from "./_api.js";

const rotaColeta_api = {
    GetList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`RotaColeta/GetList`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`RotaColeta/GetItem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    Post: (model) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`RotaColeta`, model)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    Put: (model) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`RotaColeta`, model)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    }, Put: (model) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`RotaColeta`, model)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    }, GetLocalidadesPorBairroEModalidade: (id, bairro) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`RotaColeta/GetLocalidadesPorBairroEModalidade/${id}/${bairro}`).then(result => {
                resolve(result);
            }).catch(e => {
                reject(e);
            });
        });
        return promise;
    },
    GetModalidadesContratosPorVeiculo: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`RotaColeta/GetModalidadesContratosPorVeiculo/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;
    },
    GetBairrosPorModalidade: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`RotaColeta/GetBairrosPorModalidade/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;
    }, GetVeiculosDisponiveis: (transportadorId = 0) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`RotaColeta/GetVeiculosDisponiveis/${transportadorId}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetDestinosDisponiveisPorVeiculo: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`RotaColeta/GetDestinosPorVeiculo/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
}
export default rotaColeta_api;